import React from 'react';

const TermsOfService: React.FC = () => {
  return (
    <div>
      <h1>Terms of Service</h1>
      <p>This is the terms of service page for PortfoliosLab. The actual content will be added later.</p>
    </div>
  );
};

export default TermsOfService;
